/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getSessionStatus,
  commonAction,
  getDepartments,
  getCurrentUser,
  getStatuses,
  getSeverities,
} from "@neumetric/blueprint-lib/store";
import { riskActions } from "../../store";

export const MitigatorHomeScreen = (props) => {
  const initialized = React.useRef(false);
  const dispatch = useDispatch();
  const sessionStatus = useSelector(getSessionStatus);
  const departments = useSelector(getDepartments);
  const severities = useSelector(getSeverities);
  const statuses = useSelector(getStatuses);

  const isListLoaded = Array.isArray(departments) && Array.isArray(severities) && Array.isArray(statuses);
  const user = useSelector(getCurrentUser);
  React.useEffect(() => {
    if (sessionStatus === "LOGGED_IN" && !initialized.current) {
      initialized.current = true;
      dispatch(commonAction.fetchDepartments());
      dispatch(commonAction.fetchActiveUsers({ orgId: user.org.id }));
      dispatch(commonAction.fetchStatuses());
      dispatch(commonAction.fetchSeverity());
      dispatch(commonAction.fetchPriorities());
      dispatch(riskActions.fetchThreats());
      dispatch(riskActions.fetchVulnerabilities());
      dispatch(riskActions.fetchAssetList());
      dispatch(riskActions.fetchAssetTypeList());
      dispatch(riskActions.fetchSources());
    }
  }, [sessionStatus]);
  return <React.Fragment>{isListLoaded && props.children}</React.Fragment>;
};
